import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemType } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import { SlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';

// 填充方式
export const sizeTypes = [
    { key: SlideSizeType.SLIDE_SIZE_4_3.toString(), content: i18n.t('标准（4：3）') },
    { key: SlideSizeType.SLIDE_SIZE_16_9.toString(), content: i18n.t('宽屏（16：9）') },
];

export const FORM_CONFIGS: FormConfig[] = [
    {
        name: FormItemName.SLIDE_SIZE_SELECT,
        type: FormItemType.SELECT,
        options: {
            selectOptions: sizeTypes,
        },
    },
];

